/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class TreeItemOptions {
        public id: string;
        public text: string;
        public treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource;
        public variableType: Wars.Domain.Model.Codes.Enums.VariableType;
        public isSystemLevel: boolean;
        public complexObjectProperty?: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty;
        public listSectionId?: string;
        public isClaimWithValue?: boolean;
        public queryConfigurationId?: string;
        public placeholder?: Wars.Domain.Model.Codes.Enums.Placeholder;
        public isRequired?: boolean;
        public isPlaceholderList?: boolean;
        public userClaimDefinitionId?: string;
        public interProcessApiId?: string;
        public claimUniqueId?: string;

        constructor(id: string,
            text: string,
            treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource,
            variableType: Wars.Domain.Model.Codes.Enums.VariableType,
            isSystemLevel: boolean)
        {
            this.id = id;
            this.text = text;
            this.treeItemSource = treeItemSource;
            this.variableType = variableType;
            this.isSystemLevel = isSystemLevel;
        }
    }
}